import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { TenantModel } from '@/api/models/tenant';
import { UnitModel } from '@/api/models/unit';
import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { Id } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_GetAllInBuilding_Unit = {
  buildingId?: Id;
};

export type ApiResponse_GetAllInBuilding_Unit = Array<
  UnitModel & {
    tenants: Array<Pick<TenantModel, 'full_name'>>;
  }
>;

const METHOD = 'GET';
const ENDPOINT = 'unit/all';
export const QUERY_KEY = (params?: ApiRequest_GetAllInBuilding_Unit) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetAllUnitsInBuilding = (
  params?: ApiRequest_GetAllInBuilding_Unit,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      try {
        const data = await handleApiCall<
          ApiResponse_GetAllInBuilding_Unit,
          ApiRequest_GetAllInBuilding_Unit
        >(session, METHOD, getResolvedEndpoint(ENDPOINT, {}), params);

        return data;
      } catch (err) {
        enqueueSnackbar('Failed to fetch units.', { variant: 'error' });

        // eslint-disable-next-line no-console
        console.error(err);

        throw err;
      }
    },
  });
};
